export const TOKENEX_ID = process.env.REACT_APP_TOKENEX_ID;
export const TOKENEX_URL = process.env.REACT_APP_TOKENEX_URL;
